import { useEffect } from 'react'

import { BroadcastChannels } from 'shared/constants/broadcast/channels'
import { DesktopBroadcastMessages } from 'shared/constants/broadcast/desktop'
import { DesktopGridItem } from 'shared/types/desktop-grid'
import { createTypedBroadcastChannel } from 'shared/utils/broadcastChannel'

type UseDesktopBroadcastListenerOptions = {
  commitManualItems: (
    value:
      | DesktopGridItem[]
      | ((prevItems: DesktopGridItem[]) => DesktopGridItem[])
  ) => void
}

/** Removes desktop shortcuts in response to desktop broadcast messages. */
export const useDesktopBroadcastListener = ({
  commitManualItems
}: UseDesktopBroadcastListenerOptions) => {
  useEffect(() => {
    const desktop = createTypedBroadcastChannel(BroadcastChannels.DESKTOP)
    const unsubscribe = desktop.subscribe(message => {
      switch (message.type) {
        case DesktopBroadcastMessages.REMOVE_ITEM: {
          commitManualItems(prevItems => {
            const next = prevItems.filter(
              item => item.id !== message.payload.id
            )
            // Preserve identity when the id wasn't present — a changed
            // reference would rewrite the whole base layout with the items'
            // current (possibly mid-reflow) positions.
            return next.length === prevItems.length ? prevItems : next
          })
          break
        }
      }
    })
    return () => {
      unsubscribe()
      desktop.close()
    }
  }, [commitManualItems])
}
